import { isDefined } from "@clipboard-health/util-ts";
import { useSession } from "@src/appV2/Auth/api/useSession";
import { useEffect } from "react";

import { markEngagementSurfaceViewed } from "./usePushNotificationPromptState";

/**
 * Marks that the current workplace user has viewed a primary engagement surface
 * (the daily-view calendar for standard workplaces, the cases page for
 * home-health workplaces). This enables the push notification soft prompt trigger.
 */
export function useMarkEngagementSurfaceViewed(): void {
  const { user } = useSession();
  const workplaceUserId = user?._id;

  useEffect(() => {
    if (isDefined(workplaceUserId)) {
      markEngagementSurfaceViewed(workplaceUserId);
    }
  }, [workplaceUserId]);
}
